<div class="flex flex-col flex-[1] min-h-0">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-[8px]">
      <span class="text-[22px] text-[#262626]">Roles & Permissions</span>
      <img
        src="/assets/svg/info.svg"
        width="16"
        height="16"
        matTooltip="View and manage user roles and their permissions. To assign roles to members, go to Members."
        matTooltipClass="blue-md-tooltip wider"
      />
    </div>
    <span
      matTooltip="Only admins can create roles"
      matTooltipClass="blue-md-tooltip wider"
      [matTooltipDisabled]="isAdmin()"
    >
      <gnx-button type="blue" size="h32" [disabled]="!isAdmin()" (click)="openCreateDialog()">
        + Create Role
      </gnx-button>
    </span>
  </div>

  <div class="mt-[18px] flex-[1] overflow-auto min-h-[200px]">
    @if (auth0Store.allRolesLoading()) {
      <div class="pt-[35px] text-center">
        <gnx-dots-loader />
      </div>
    }

    @if (auth0Store.allRolesLoaded()) {
      @let roles = auth0Store.allRolesForDisplay();
      @if (roles?.length) {
        @for (role of roles; track role.role) {
          <div
            class="role-card group"
            role="button"
            tabindex="0"
            (click)="openRoleDialog(role)"
            (keydown.enter)="openRoleDialog(role)"
            (keydown.space)="openRoleDialog(role)"
          >
            <div class="flex flex-col flex-[1]">
              <span class="text-[22px] text-[#373737]">{{ role.role | snakeCaseTitle }}</span>
              <span class="text-[14px] text-[#646464]">
                {{ role.assigned_users?.length || 0 }} user{{ (role.assigned_users?.length || 0) === 1 ? '' : 's' }}
                assigned
              </span>
            </div>

            <div class="flex items-center gap-[4px]">
              @for (user of getVisibleUsers(role); track user.email; let i = $index) {
                <gnx-avatar
                  [bgColor]="getAvatarColor(i)"
                  [size]="36"
                  [name]="user.name || user.email"
                  [matTooltip]="user.name || user.email"
                  matTooltipClass="blue-md-tooltip wider"
                />
              }
              @if (getOverflowCount(role) > 0) {
                <div
                  class="flex items-center justify-center w-[36px] h-[36px] rounded-full bg-[#e0e3e6] text-[#262626] text-[12px] font-semibold"
                  [matTooltip]="getOverflowUsersTooltip(role)"
                  matTooltipClass="blue-md-tooltip wider"
                >
                  +{{ getOverflowCount(role) }}
                </div>
              }
            </div>

            @if (isAdmin()) {
              <button class="kebab-btn" [matMenuTriggerFor]="roleMenu" (click)="$event.stopPropagation()">
                <img src="/assets/svg/more-actions-blue.svg" width="18" height="18" />
              </button>
              <mat-menu #roleMenu="matMenu">
                <button mat-menu-item (click)="openRoleDialog(role)">Edit</button>
              </mat-menu>
            }
          </div>
        }
      } @else {
        <div class="flex flex-col items-center pt-[60px]">
          <span class="text-[18px] text-[#7a7b85]">No roles defined yet</span>
          @if (isAdmin()) {
            <span class="text-[14px] text-[#999] mt-[8px]">Create your first role to get started</span>
          }
        </div>
      }
    }
  </div>
</div>
